
import { useTranslation } from 'react-i18next';

export default function HowItWorksSection() {
  const { t } = useTranslation();

  const steps = [
    {
      number: t('common:howItWorks.step1Number'),
      title: t('common:howItWorks.step1Title'),
      description: t('common:howItWorks.step1Desc'),
      icon: 'ri-chat-smile-3-line',
    },
    {
      number: t('common:howItWorks.step2Number'),
      title: t('common:howItWorks.step2Title'),
      description: t('common:howItWorks.step2Desc'),
      icon: 'ri-home-heart-line',
    },
    {
      number: t('common:howItWorks.step3Number'),
      title: t('common:howItWorks.step3Title'),
      description: t('common:howItWorks.step3Desc'),
      icon: 'ri-rocket-line',
    },
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            {t('common:howItWorks.title')}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            {t('common:howItWorks.subtitle')}
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-emerald-200 via-emerald-300 to-emerald-200 transform -translate-y-1/2 z-0"
               style={{ top: '120px' }}></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-100 h-full">
                  <div className="relative mb-6">
                    <div className="w-24 h-24 mx-auto bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-full flex items-center justify-center shadow-lg">
                      <i className={`${step.icon} text-4xl text-white`}></i>
                    </div>
                    <div className="absolute -top-2 -right-2 w-12 h-12 bg-amber-400 rounded-full flex items-center justify-center shadow-md border-4 border-white" style={{ left: 'calc(50% + 24px)' }}>
                      <span className="text-sm font-bold text-slate-900">{step.number}</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3 text-center">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 text-center leading-relaxed">
                    {step.description}
                  </p>
                </div>
                {index < steps.length - 1 && (
                  <div className="md:hidden flex justify-center my-4">
                    <i className="ri-arrow-down-line text-3xl text-emerald-400"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <button
            onClick={scrollToContact}
            className="inline-flex items-center gap-3 bg-gradient-to-r from-emerald-600 to-emerald-500 text-white px-10 py-4 rounded-full text-lg font-semibold hover:from-emerald-700 hover:to-emerald-600 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-calendar-check-line text-2xl"></i>
            {t('common:howItWorks.ctaButton')}
          </button>
          <p className="text-sm text-slate-500 mt-4">
            {t('common:howItWorks.ctaNote')}
          </p>
        </div>
      </div>
    </section>
  );
}
